import React, { Component } from 'react';
import { firebaseRef } from '../firebase.js';
import { withRouter } from 'react-router';
import Modal from 'react-modal';
import FaClose from 'react-icons/lib/fa/close';

class Userimage extends Component {
  constructor(props){
    super(props);
    this.state = {
      image: '',
      progress: 100,
      imgUrl: '',
      start: false,
      hasImage: false,
      modal: false,
    };
    this.profileImage = this.profileImage.bind(this);
    this.openImage = this.openImage.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentWillMount(){
    var that=this;
    var userId = that.props.match.params.user;
    var storageRef = firebaseRef.storage().ref();
    var mountainImagesRef = storageRef.child('userImages/'+userId);
    mountainImagesRef.getDownloadURL().then(function(url) {
      that.setState({ imgUrl: url, hasImage: true });
    }).catch(function(error) {

      // A full list of error codes is available at
      // https://firebase.google.com/docs/storage/web/handle-errors
      switch (error.code) {
        case 'storage/object_not_found':
          alert("File doesn't exist");
          break;

        case 'storage/unauthorized':
          alert("User doesn't have permission to access the object")
          break;

        case 'storage/canceled':
           alert("User canceled the upload")
          break;

        case 'storage/unknown':
          alert("Unknown error occurred, inspect the server response");
          break;

          default:
          console.log("Theres no image.");
      }
    });
  }

  profileImage(event){
    var that=this;
    var userId = that.props.match.params.user;
    this.setState({ progress: 1, image: 1 + '%', start: true });
    var filename = this.fileInput.files[0];
    var storageRef = firebaseRef.storage().ref();
    var mountainImagesRef = storageRef.child('userImages/'+userId);
    var task = mountainImagesRef.put(filename);

    task.on("state_changed", function progress(datasnapShot){
      var percentage = (datasnapShot.bytesTransferred / datasnapShot.totalBytes) * 100;
      var res = percentage.toFixed(0);
      that.setState({ progress: percentage, image: res + '%' });
    },
    function error(err){
      alert("Something went wrong please check your file or try agian!");
    },
    function complete(datasnapShot){
            alert("Image was added succesfully! Refresh the page to see the image.");
    }
  );
  }

  openImage(){
    this.setState({ modal: true });
  }

  closeModal(){
    this.setState({ modal: false });
  }

  render(){
    return(
        <div className="paitent-image">
        <Modal
        isOpen={this.state.modal}
        onRequestClose={this.closeModal}
        className="Modal"
        contentLabel="Example Modal"
        >
          <div className="modal-close"><button type="button" onClick={this.closeModal} className="modal-close-button"> <FaClose /> </button></div>
          <div style={{backgroundImage:'url(' + this.state.imgUrl + ')'}} className="modal-image"></div>
        </Modal>
        <form className="user-forms" align="center">
            {this.state.hasImage ? (
              <div>
              <div className="hasImage-div-file" style={{backgroundImage:'url(' + this.state.imgUrl + ')'}} onClick={this.openImage}>
              </div>
              <div>
              <label htmlFor="user-image" style={{width: this.state.progress + '%'}} className={`file-label-change ${this.state.start ? 'progress-color' : ''}`}>
                <h3 style={{padding: 10}}>Change {this.state.image}</h3>
              </label>
              </div>
              </div>
            ):(
              <div className="profile-image-none">
              <label htmlFor="user-image" style={{width: this.state.progress + '%'}} className={`file-label-none ${this.state.start ? 'progress-color' : ''}`}>
                <h3>Paitent Image {this.state.image}</h3>
              </label>
              </div>
            )}
            <input type="file" id="user-image" className="user-inputs" onChange={this.profileImage} ref={input => {this.fileInput = input;}}/>
        </form>
        </div>
    );
  }
}

export default withRouter(Userimage);



// WEBPACK FOOTER //
// ./src/routes/Paitent/userImage.js